__turbopack_context__.v({
  "accordion__item": "styles-module-scss-module__MvAzSa__accordion__item",
  "accordion__item_content": "styles-module-scss-module__MvAzSa__accordion__item_content",
  "accordion__item_title": "styles-module-scss-module__MvAzSa__accordion__item_title",
  "accordion__item_trigger": "styles-module-scss-module__MvAzSa__accordion__item_trigger",
});
